import { render, staticRenderFns } from "./LiveSocialGoogleButton.vue?vue&type=template&id=6cb264d4&scoped=true&"
import script from "./LiveSocialGoogleButton.vue?vue&type=script&lang=ts&"
export * from "./LiveSocialGoogleButton.vue?vue&type=script&lang=ts&"
import style0 from "./LiveSocialGoogleButton.vue?vue&type=style&index=0&id=6cb264d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb264d4",
  null
  
)

export default component.exports